import { LedgerActivityReportItem, BillState, LedgerActivityReportAccountType } from '@mews-commander/data-access';
import { EnterpriseLink } from '@mews-commander/ui';
import { CompanyDetailTabs } from '../../companyDetail';

interface LedgerActivityReportBillLinkProps {
    ledgerItem: LedgerActivityReportItem;
}

export const LedgerActivityReportBillLink = ({ ledgerItem }: LedgerActivityReportBillLinkProps) => {
    const { owner, bill } = ledgerItem;

    if (!bill) {
        return null;
    }

    if (bill.state === BillState.Closed && bill.id) {
        return (
            <EnterpriseLink to="Bill/Detail/$id" params={{ id: bill.id }} variant="basic">
                {bill?.name || ''}
            </EnterpriseLink>
        );
    }

    if (bill.state === BillState.Open && owner) {
        if (owner.type === LedgerActivityReportAccountType.Customer) {
            return (
                <EnterpriseLink
                    to="Billing/Account/$accountId"
                    params={{ accountId: owner.id || '' }}
                    search={{ billId: bill.id }}
                    variant="basic"
                >
                    {bill?.name || ''}
                </EnterpriseLink>
            );
        }

        if (owner.type === LedgerActivityReportAccountType.Company) {
            return (
                <EnterpriseLink
                    to="Company/Detail/$id"
                    params={{ id: owner.id || '' }}
                    search={{ billId: bill.id, tab: CompanyDetailTabs.Billing }}
                    variant="basic"
                >
                    {bill?.name || ''}
                </EnterpriseLink>
            );
        }
    }

    return <>{bill?.name || ''}</>;
};
